import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import { createUpdatedSearchParams } from "./hookUtils";

export function useSearchParamActions() {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParam = useCallback(
    (name, value) => {
      setSearchParams(
        createUpdatedSearchParams(searchParams, {
          set: [{ name, value }],
        })
      );
    },
    [searchParams, setSearchParams]
  );

  const removeSearchParam = useCallback(
    (name) => {
      setSearchParams(
        createUpdatedSearchParams(searchParams, {
          remove: [name],
        })
      );
    },
    [searchParams, setSearchParams]
  );

  const updateSearchParams = useCallback(
    (params = []) => {
      setSearchParams(
        createUpdatedSearchParams(searchParams, {
          set: params,
        })
      );
    },
    [searchParams, setSearchParams]
  );

  const removeSearchParams = useCallback(
    (params = []) => {
      setSearchParams(
        createUpdatedSearchParams(searchParams, {
          remove: params,
        })
      );
    },
    [searchParams, setSearchParams]
  );

  return {
    searchParams,
    updateSearchParam,
    removeSearchParam,
    updateSearchParams,
    removeSearchParams,
  };
}
